<template>
  <v-text-field
    color="neutralGray"
    filled
    v-bind="$attrs"
    v-on="$listeners"
    v-model.trim="text"
    :label="label ? inputLabel : undefined"
    :rules="
      required
        ? [
            (v) =>
              !!(v ? v.trim() : '') ||
              (requiredMessage != null
                ? requiredMessage
                : $t('widget.fieldRequired')),
            (v) =>
              regExp.test(v) ||
              (validationMessage != null ? validationMessage : $t('widget.fieldInvalid')),
          ]
        : []
    "
    :required="required"
    :maxlength="maxlength"
  >
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
    <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
      >
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "ATextField",
  props: {
    value: {
      type: String | null,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    requiredMessage: {
      type: String,
      default: null,
    },
    maxlength: {
      type: Number,
      default: 10000,
    },
    required: {
      type: Boolean,
      default: false,
    },
    regExp: {
      type: RegExp,
      //default: () => /[a-zA-Z]/,
      default: () => /[一-龠ぁ-ゔァ-ヴーa-zA-Zａ-ｚＡ-Ｚ々〆〤]/,
    },
    validationMessage: {
      type: String,
      default: null,
    },
  },
  computed: {
    inputLabel() {
      return this.label + (this.required ? " *" : "");
    },
    text: {
      get() {
        return String(this.value || "").trim();
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
  },
};
</script>

<style scoped>
.v-text-field--filled {
  border-radius: 0px !important;
}
.textField /deep/ input {
  line-height: 21px !important;
}
</style>